import axios from 'axios';

/**
 * Global axios setup for the dashboard. Imported once for its side effects
 * (see main.jsx). All api modules use the default axios instance, so these
 * interceptors cover every backend call. S3 uploads use native fetch and are
 * unaffected.
 *
 * Multi-city: the backend now authenticates dashboard routes and authorizes
 * the target city against the logged-in user. The dashboard must therefore
 * send the CMS auth token on every request.
 */

// Attach the bearer token (set at login) to outgoing requests.
axios.interceptors.request.use((config) => {
  const token = localStorage.getItem('authToken');
  if (token) {
    config.headers = config.headers || {};
    if (!config.headers.Authorization) {
      config.headers.Authorization = `Bearer ${token}`;
    }
  }
  return config;
});

// On 401 (missing/expired/invalid token) drop auth state and return to the
// login gate. Guarded so a storm of concurrent 401s triggers a single reload,
// and so the login request itself isn't caught in a loop.
let handling401 = false;
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status;
    const url = error?.config?.url || '';
    const isLogin = url.includes('/auth/cms/login');
    if (status === 401 && !isLogin && !handling401) {
      handling401 = true;
      localStorage.removeItem('isAuthenticated');
      localStorage.removeItem('authToken');
      if (typeof window !== 'undefined') window.location.reload();
    }
    return Promise.reject(error);
  }
);
